// Weekly streak ("racha") tracking, stored in localStorage.
// A "week" is a Monday-anchored ISO-style bucket, computed as a monotonic
// integer index so comparisons work cleanly across month/year boundaries.
//
// Activity is registered only when the user performs a meaningful action on the
// QuickStart screen (tapping one of its buttons) — merely viewing the screen
// does NOT count, so the "¡No pierdas tu racha!" nudge can show when a live
// streak hasn't been continued yet this week.

const RACHA_KEY = "negoia:racha";
const WEEK_MS = 7 * 24 * 60 * 60 * 1000;

// Monotonic week index anchored to Monday 00:00 local time.
function weekIndex(input) {
  const date = new Date(input);
  const dow = (date.getDay() + 6) % 7; // 0 = Monday
  date.setHours(0, 0, 0, 0);
  date.setDate(date.getDate() - dow); // back to Monday
  return Math.floor(date.getTime() / WEEK_MS);
}

function readRacha() {
  try {
    const raw = localStorage.getItem(RACHA_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (
      parsed &&
      typeof parsed.weeks === "number" &&
      typeof parsed.lastIdx === "number"
    ) {
      return parsed;
    }
    return null;
  } catch {
    return null;
  }
}

function writeRacha(value) {
  try {
    localStorage.setItem(RACHA_KEY, JSON.stringify(value));
  } catch {
    /* private mode — streak just won't persist */
  }
}

// Read-only: what to display right now on QuickStart.
// Returns { weeks, activeThisWeek, alive }.
//   - activeThisWeek: user already acted this week → show "🔥 N semanas seguidas"
//   - alive (and not active): streak survives from last week but not continued
//     this week yet → show "¡No pierdas tu racha!"
//   - neither: no history or streak broken → caller shows the nudge / nothing
export function getRachaDisplay(now = Date.now()) {
  const stored = readRacha();
  if (!stored) return { weeks: 0, activeThisWeek: false, alive: false };
  const diff = weekIndex(now) - stored.lastIdx;
  if (diff <= 0) return { weeks: stored.weeks, activeThisWeek: true, alive: true };
  if (diff === 1) return { weeks: stored.weeks, activeThisWeek: false, alive: true };
  return { weeks: 0, activeThisWeek: false, alive: false }; // broken
}

// Call when the user performs a meaningful action. Advances / resets the streak.
export function registerRachaActivity(now = Date.now()) {
  const cur = weekIndex(now);
  const stored = readRacha();
  let weeks;
  if (!stored) {
    weeks = 1;
  } else {
    const diff = cur - stored.lastIdx;
    if (diff <= 0) weeks = stored.weeks; // already counted this week
    else if (diff === 1) weeks = stored.weeks + 1; // consecutive week
    else weeks = 1; // gap → restart
  }
  const next = { weeks, lastIdx: cur };
  writeRacha(next);
  return next;
}
